import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class ProductV2Services {
  createLedgerEntry = async (payload) => {
    const ledgerEntry = await Helpers.post({
      url: Constants.LEDGER_ENTRY,
      data: payload,
    });
    return ledgerEntry;
  }

  updateLedgerEntry = async (payload) => {
    const ledgerEntry = await Helpers.put({
      url: Constants.LEDGER_ENTRY,
      data: payload,
    });
    return ledgerEntry;
  }
}

export default new ProductV2Services();
